var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"frag",rawName:"v-frag"}]},[_c('app-bar-simple',{attrs:{"menu":_vm.layoutProps}}),_c('v-main',[_c('router-view')],1),_c('GlobalFooter',{attrs:{"element-props":_vm.footerProps}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }